module.exports = __webpack_public_path__ + "static/media/Agro-Dealer infographic - Mobile - 07-06-2024 C.76a6acf9.gif";